
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"526.962","height":"485.009","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M84.835 5.255L.505 480.507c-.506 3.997 33 3 34.327.406l195.264-177.54-27.85 177.224c1.33 5.808 41.314 4.615 43.259-.09l29.846-177.768 130.154 177.768c4 4 33 4 36.311.09L526.454 6.085c.633-3.55-32.054-5.25-35.054-1.25L297.82 182.796 326.304 5.255c-1.922-5.688-37.84-6.96-43.99 0l-29.116 177.858L120.505 5.507c-1.568-2.098-35.145-3.21-35.67-.252z","stroke":"#000"}}),_c('g',{attrs:{"fill":"#fdd100","stroke":"#000"}},[_c('path',{attrs:{"d":"M418.938 350.38l-8.766 51.245c-.476 2.78-7.111 4.28-10.63 2.238l-39.888-23.161c-5.203-3.021-5.933-7.6-5.315-11.19l8.84-51.357-32.449-17.231c-3.776-2.005-9.274-7.423-8.336-12.588l22.238-122.38c1.17-5.527 5.134-7.648 6.35-8.027l44.57-19.862 3.655-18.74c1.324-5.484 2.783-5.826 4.979-7.105l51.078-25.232c4.057-1.684 8.191-2.755 8.839.112l-6.044 35.47c18.472-1.765 31.541 6.79 28.212 28.889-2.425 16.187-21.072 28.898-37.505 26.496l-19.916 115.76c15.978-1.71 28.847 7.076 28.651 24.102.317 10.103-11.302 34.526-38.563 32.56zM107.843 136.591l8.766-51.246c.476-2.78 7.112-4.28 10.63-2.237l39.889 23.16c5.202 3.022 5.932 7.6 5.314 11.19l-8.839 51.357 32.448 17.231c3.776 2.006 9.274 7.424 8.336 12.588l-22.238 122.38c-1.17 5.527-5.134 7.648-6.35 8.028l-44.569 19.862-3.655 18.74c-1.325 5.483-2.784 5.826-4.98 7.105L71.518 399.98c-4.058 1.684-8.192 2.755-8.84-.112l6.045-35.469c-18.473 1.764-31.542-6.791-28.212-28.89 2.424-16.186 21.07-28.897 37.504-26.496l19.917-115.76c-15.98 1.71-28.848-7.076-28.652-24.102-.317-10.102 11.302-34.526 38.563-32.56z"}})])])
          )
        }
      }
    